import type { CoreDslFormTerm, PropertyType } from '@salescore/core'

// CoreDslFormTerm(保存済み条件の左辺)から項目型を導出する。ラベル生成とは無関係の純粋な型導出。
// literal は array リテラルのときだけ array と判定し、それ以外は型を持たない(undefined)。
// snapshotVariable / recordNodeVariable は参照先の property.type をそのまま返す。
export const getPropertyTypeFromCoreDslTerm = (term: CoreDslFormTerm | undefined): PropertyType | undefined => {
  if (term === undefined) return undefined

  switch (term.type) {
    case 'literal': {
      return term.literalType === 'array' ? 'array' : undefined
    }
    case 'snapshotVariable':
    case 'recordNodeVariable': {
      return term.property.type
    }
  }
}
